(function ($) {
  $(document).ready(function ($) {
    // Your site's jQuery goes inside this .ready() function.

    /*****************************************************************
     Mobile Menu
    ******************************************************************/
    $('a[href="#nav"]').click(function (e) {
      e.preventDefault();
      $('html').toggleClass('nav-open');
    });
    $('.mobile-menu-bg').click(function (e) {
      $('html').removeClass('nav-open');
    });

    $('body').on('click', '.site-header nav a[href="#"]', function (e) {
      e.preventDefault();
    });

    $('body').on('click', '.site-header nav a', function (e) {
      if ($(window).width() >= 768) {
        return;
      }

      var slideOptions = {
        easing: $.bez([0.2, 1, 0.25, 1]),
        duration: 700,
      };

      var $submenu = $(this).siblings('.sub-menu');
      var $othersubmenus = $('.site-header .sub-menu').not($submenu);
      if ($submenu.length) {
        e.preventDefault();

        if ($submenu.is('.open')) {
          $submenu.removeClass('open').stop().slideUp(slideOptions);
        } else {
          $othersubmenus.removeClass('open').stop().slideUp(slideOptions);
          $submenu.addClass('open').stop().slideDown(slideOptions);
        }
      }
    });
    /*****************************************************************
     END Mobile Menu
    ******************************************************************/

    /*****************************************************************
      Add scroll direction and scrolled classes
    ******************************************************************/
    var lastScrollTop = 0;
    var scrollBufferDown = 10;
    var scrollBufferUp = 10;
    var checkScrolling = function () {
      var currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScroll > lastScrollTop + scrollBufferDown) {
        $('html').addClass('scrolling-down');
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      } else if (currentScroll < lastScrollTop - scrollBufferUp) {
        $('html').removeClass('scrolling-down');
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      }

      if (currentScroll > 10) {
        $('html').addClass('scrolled');
      } else {
        $('html').removeClass('scrolled');
      }
    };
    $(window).scroll(checkScrolling);

    /*****************************************************************
      For when we do a img src="example.svg" SVG use instead of the 
      <svg> html markup
    ******************************************************************/

    $('img.svg').each(function () {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find('svg');

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
          if (
            !$svg.attr('viewBox') &&
            $svg.attr('height') &&
            $svg.attr('width')
          ) {
            $svg.attr(
              'viewBox',
              '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width')
            );
          }

          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        'xml'
      );
    });

    /*****************************************************************
     Accordions
    ******************************************************************/
    if ($('section.accordion').length) {
      $('.accordion-tab .top').click(function (event) {
        var parent = $(this).parent('.accordion-tab'),
          botOpen = $(parent).children('.bot'),
          botHeight = $(botOpen).children('.desc').outerHeight(true);

        if ($(parent).hasClass('open')) {
          $(parent).removeClass('open');
          $(botOpen).css('height', 0);
        } else {
          $('.accordion-tab').each(function (index, el) {
            var botReset = $(this).children('.bot');
            $(this).removeClass('open');
            $(botReset).css('height', '0');
          });

          $(parent).addClass('open');
          $(botOpen).css('height', botHeight);
        }
      });

      // In case they open a tab and then expand or shrink their screen
      $(window).resize(function (event) {
        if ($('.accordion-tab.open')) {
          var getBot = $('.accordion-tab.open').children('.bot');
          newHeight = $('.accordion-tab.open')
            .children('.bot')
            .children('.desc')
            .outerHeight(true);

          $(getBot).css('height', newHeight);
        }
      });
    }
    /*****************************************************************
     END Accordions
    ******************************************************************/

    /*****************************************************************
      Category pricing accordion
     ******************************************************************/
    $('.ship-category-heading').click(function () {
      var $this = $(this);
      var $details = $this.next('.ship-category-details');
      var $wrapper = $this.parent('.ship-category');

      var slideOptions = {
        easing: $.bez([0.2, 1, 0.25, 1]),
        duration: 600,
      };

      if ($wrapper.hasClass('is-open')) {
        $details.stop().slideUp(slideOptions);
        $wrapper.removeClass('is-open');
      } else {
        $details.stop().slideDown(slideOptions);
        $wrapper.addClass('is-open');
      }
    });

    // Clicking the Reserve Now button shouldn't toggle the accordion
    $('.ship-category-heading .btn').click(function (e) {
      e.stopPropagation();
    });

    // On page load, we want to open the first category
    // of every group that isn't sold out
    $('.room-group-heading').each(function () {
      $(this)
        .nextUntil('.room-group-heading')
        .each(function () {
          if (!$('.btn.is-sold_out', this).length) {
            $(this).addClass('is-open');
            $('.ship-category-details', this).show();
            return false;
          }
        });
    });

    // Deck plans modal slider
    var $deckSelect = $('#deckplan-select');
    var $deckSlider = $('.deckplan-slider')
      .flickity({
        prevNextButtons: false,
        pageDots: false,
        fade: true,
      })
      .on('change.flickity', function (event, index) {
        var $slide = $('.deckplan-slider .slide').eq(index);
        $deckSelect.val($slide.index());
      });

    $deckSelect.on('change', function () {
      var selectedDeck = $(this).val();
      $deckSlider.flickity('select', selectedDeck);
    });

    var $deckModal = $('.modal--deckplans');
    $('.js-modal-deckplans').click(function (e) {
      e.preventDefault();
      $deckModal.toggleClass('is-open');
      $deckSlider.flickity('resize');

      var deck = $(this).data('deck');
      if (deck) {
        var $slide = $('.deckplan-slider .slide[data-deck="' + deck + '"]');
        $deckSlider.flickity('select', $slide.index(), false, true);
      }
    });

    $('.the-modal button.close').click(function (e) {
      e.preventDefault();
      $('.the-modal').removeClass('is-open');
    });

    $('.the-modal .modal-window').click(function (e) {
      e.stopPropagation();
    });
    $('.the-modal').click(function (e) {
      $(this).removeClass('is-open');
    });
    /*****************************************************************
      END Category pricing accordion
    ******************************************************************/

    /*****************************************************************
      Vacation Single Page
    ******************************************************************/
    // init scroll magic
    var smcontroller = new ScrollMagic.Controller();
    var mainNavHeight = $('header.site-header').outerHeight(true);
    var cruiseNavHeight = $('section.cruise-nav').outerHeight();
    var offsetHeight = mainNavHeight + cruiseNavHeight;
    var isMobile = window.matchMedia(
      'only screen and (max-width: 949px)'
    ).matches;

    if (isMobile) {
      $('.cruise-nav .meta-contain').on('click', function () {
        $('.cruise-nav .cruise-nav-contain').slideToggle(200);
        $('.cruise-nav .meta-contain').toggleClass('open-menu');
      });
    }

    $('section.cruise-nav').css({ top: mainNavHeight + 'px' });
    $('#vacation-section-wrap').each(function () {
      var nav = $('section.cruise-nav');
      var toggleNav = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -offsetHeight,
        triggerHook: 0,
      })
        .setClassToggle('section.cruise-nav, body', 'vacation-fixed')
        //.addIndicators()
        .addTo(smcontroller);
    });

    if ($('.itinerary-slider').length) {
      var $itslider = $('.itinerary-slider')
        .flickity({
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: true,
          draggable: false,
          adaptiveHeight: true,
        })
        .on('change.flickity', function (event, index) {
          var tabs = $('.stops .grouping').children();

          $(tabs).removeClass('active');
          $(tabs[index]).addClass('active');
        });

      $('.stops .grouping .top').click(function (event) {
        var i = $(this).index();

        $itslider.flickity('select', i);
      });
    }
    // end itinerary section slider

    // Large Photo Text Box section,
    // if multiple images are added, make it a slider

    if ($('.sectionslider').length) {
      $('.sectionslider').each(function (index, el) {
        var $me = $(this);
        var $sectionslider = $($me).flickity({
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: true,
          draggable: false,
          adaptiveHeight: true,
        });
      });
    }

    // Vacation Hero, if it needs to be a slider,
    // if multiple images are added, make it a slider
    if ($('.cruise-hero-slider').length) {
      $('.cruise-hero-slider').each(function (index, el) {
        var $me = $(this);
        var $vacaHero = $($me).flickity({
          wrapAround: true,
          prevNextButtons: true,
          pageDots: true,
          imagesLoaded: true,
          draggable: false,
          adaptiveHeight: false,
        });
      });
    }
    /*****************************************************************
      END Vacation Single Page
    ******************************************************************/

    /*****************************************************************
      Home Page
    ******************************************************************/
    if ($('main.home-page').length) {
      $('section.home-hero').flickity({
        fade: true,
        prevNextButtons: true,
        //autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
      });
    }
    /*****************************************************************
      END Home Page
    ******************************************************************/

    /*****************************************************************
    Cookie Handling
  ******************************************************************/
    function getCookie(cname) {
      var name = cname + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    /*****************************************************************
      END Cookie Handling
    ******************************************************************/

    /*****************************************************************
      Popup Handling
    ******************************************************************/

    /* Click overlay part of modal, close modal */
    /*$( "#wait-modal" ).click( function ( e ) {
      //if ( e.target != this ) return;
      setCookie( 'waitClose', 'closed', 0.5 );
      closeModal();
    } );*/

    $('button.close-modal').click(function (e) {
      //if ( e.target != this ) return;
      setCookie('waitClose', 'closed', 2);
      closeModal();
    });

    /* Open modal function */
    function openModal(contentId) {
      $('body').addClass('modal-open');
    }

    /* Close modal function */
    function closeModal() {
      $('body').removeClass('modal-open');
    }

    if (getCookie('waitSubmit') != 'submitted') {
      if (getCookie('waitClose') != 'closed') {
        setTimeout(function () {
          if (getCookie('waitSubmit') == 'submitted') {
            return false;
          } else if (getCookie('waitClose') == 'closed') {
            return false;
          } else {
            openModal();
          }
        }, 3000);
      }
    }

    /* If this form is submitted, don't show modal for 120 days */
    $('.newsletter-form .gform_button').click(function (event) {
      setCookie('waitSubmit', 'submitted', 120);
    });
    /*****************************************************************
      END Popup Handling
    ******************************************************************/
  }); // end .ready()
})(jQuery);
